/*
When running in SPA mode, Next's route handler doesn't know to do with initial page.
 */
import React from 'react';
import { SpaError } from '@chegg-web-tools/spa-router';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { routes } = require('./routes.json');

export default function NextApp() {
  return <SpaError routes={routes} />;
}
